import Loader from 'src/components/Loader';
import Table from 'src/components/Table';
import { OccupancyReportData } from 'src/pages/Reporting/ReportingFormTypes';

interface PropertyAggregateTableProps {
  data: OccupancyReportData[] | undefined;
  isLoading: boolean;
}

const PropertyAggregateTable = ({
  data,
  isLoading,
}: PropertyAggregateTableProps) => {
  const columns: any = [
    {
      label: 'Property Name',
      cell: (data: OccupancyReportData) => data.propertyName,
    },
    {
      label: 'Total Service Requests',
      cell: (data: OccupancyReportData) => data.serviceRequestsCount,
    },
    {
      label: 'Walkthrough SRs',
      cell: (data: OccupancyReportData) => data.walkthroughServiceRequestsCount,
    },
    {
      label: 'Internal Walkthrough SRs',
      cell: (data: OccupancyReportData) =>
        data.internalWalkthroughServiceRequestsCount,
    },
    {
      label: 'Homeowner Walkthrough SRs',
      cell: (data: OccupancyReportData) =>
        data.homeOwnerWalkthroughServiceRequestsCount,
    },
    {
      label: 'Warranty SRs',
      cell: (data: OccupancyReportData) => data.warrantyServiceRequestsCount,
    },
    {
      label: 'Walkthrough %',
      cell: (data: OccupancyReportData) => {
        // Calculate percentage of walkthrough SRs out of total SRs
        const percentage =
          data.serviceRequestsCount > 0
            ? Math.round(
                (data.walkthroughServiceRequestsCount /
                  data.serviceRequestsCount) *
                  100
              )
            : 0;
        return `${percentage}%`;
      },
    },
    {
      label: 'Internal Walkthrough %',
      cell: (data: OccupancyReportData) =>
        `${data.internalWalkthroughServiceRequestsPercentage}%`,
    },
    {
      label: 'Homeowner Walkthrough %',
      cell: (data: OccupancyReportData) =>
        `${data.homeOwnerWalkthroughServiceRequestsPercentage}%`,
    },
    {
      label: 'Warranty %',
      cell: (data: OccupancyReportData) =>
        `${data.warrantyServiceRequestPercentage}%`,
    },
  ];

  return (
    <div>
      {data.length > 0 && <h3>Stats by Projects</h3>}
      {isLoading && (
        <div className="loader-container">
          <Loader center={true} />
        </div>
      )}
      {data && data.length > 0 && (
        <div className="table-container">
          <Table
            columns={columns}
            data={data}
            defaultSort={undefined}
            headerTop={undefined}
          />
        </div>
      )}
    </div>
  );
};

export default PropertyAggregateTable;
